import {Types} from './PayRollIncidentContext'

const ModalReducer = (state:any, action:any) => {
    const {payload,type} = action;
    
    switch(type){
        case Types.MODAL_PAYROLL_INCIDENT:
            return {
                ...state,
                _id:payload._id,
                editView:payload.editView,
                payRollIncident:payload.payRollIncident,
                modalPayRollIncendent:true
            }
             
        case Types.CLOSE_PAYROLL_INCIDENT_MODAL:
                 return{
                     ...state,
                     _id:"",
                     editView:"",
                     payRollIncident:{},
                     modalPayRollIncendent:false
                 }   
       
        default:
        return state;
    }
}

export default ModalReducer;